import { API_BASE_URL } from '../config/serverApiConfig';
import { api } from './api';

export type PeoplePurpose = 'assignee' | 'watcher' | 'group_member' | 'invite';

export interface Person {
  id: string;
  email: string;
  name: string;
  /** How the person is reachable here (a muted reason/role), when the API says. */
  source?: string;
}

export interface PeoplePage {
  people: Person[];
  total: number;
}

export interface PeopleQuery {
  search?: string;
  limit?: number;
  offset?: number;
}

const params = (query: PeopleQuery) => {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim()) out.search = query.search.trim();
  if (query.limit !== undefined) out.limit = query.limit;
  if (query.offset !== undefined) out.offset = query.offset;
  return out;
};

export const listPeople = async (
  nodeId: number,
  purpose: PeoplePurpose,
  query: PeopleQuery = {}
): Promise<PeoplePage> => {
  const response = await api().get(`${API_BASE_URL}r/v2/workspaces/${nodeId}/people`, {
    params: { purpose, ...params(query) },
    cache: false
  } as any);
  return response.data;
};

export const listPlatformPeople = async (query: PeopleQuery = {}): Promise<PeoplePage> => {
  const response = await api().get(`${API_BASE_URL}platform/people`, {
    params: { purpose: 'support_admin', ...params(query) },
    cache: false
  } as any);
  return response.data;
};
